import { toTypedSchema } from '@vee-validate/zod'
import * as zod from 'zod'

export const noActionCategoryValidationSchema = toTypedSchema(
    zod.object({
        comment: zod.string().trim().min(1, 'formInputs.validation.requiredText'),
    }),
)
